<template>
    <!-- Preloader -->
    <div class="loader-mask" v-show="isLoading">
        <div class="loader">
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Preloader',
    data() {
        return {
            isLoading: true
        }
    },
    mounted() {
        // Amagar el preloader després de carregar la pàgina
        window.addEventListener('load', this.hidePreloader);

        // Si la pàgina ja està carregada, amaguem el preloader
        if (document.readyState === 'complete') {
            this.hidePreloader();
        }

        // Timeout de seguretat per amagar el preloader després d'un temps màxim
        setTimeout(() => {
            this.hidePreloader();
        }, 2000);
    },
    beforeDestroy() {
        window.removeEventListener('load', this.hidePreloader);
    },
    methods: {
        hidePreloader() {
            this.isLoading = false;
        }
    }
}
</script>

<style scoped>
/* Els estils es carregaran de manera global, però podeu afegir estils específics aquí si cal */
</style>